import styled from 'styled-components';

import { borderRadius, color } from '@/theme/selectors';

export const Wrapper = styled.div`
    overflow: hidden;
    width: 100%;
    color: white;
    background-color: ${color('surface-disabled')};
    border-radius: ${borderRadius('medium')};
`;

export const Trigger = styled.button`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 16px;
    background: transparent;
    border: none;
    cursor: pointer;
    color: inherit;
`;

export const IconWrapper = styled.span<{ $isOpen: boolean }>`
    display: flex;
    transition: transform 0.2s ease;
    transform: scaleY(${({ $isOpen }) => ($isOpen ? 1 : -1)});
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 16px 16px;
    gap: 8px;
`;

export const Item = styled.div`
    gap: 12px;
    display: flex;
    background: ${color('secondary-disabled')};
    border-radius: ${borderRadius('medium')};
`;

export const ItemWrapper = styled.div`
    gap: 12px;
    padding: 24px 20px;
    background: ${color('secondary-disabled')};
    border-radius: ${borderRadius('medium')};
`;

export const ItemNumber = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 32px;
    height: 32px;
    border-radius: 8px;
    background: ${color('surface-hovered')};
`;

export const ItemBody = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 4px;
    text-align: left;
`;

export const ImageWrapper = styled.div`
    display: flex;
    justify-content: center;
    max-height: 248px;
    overflow: hidden;
    margin-top: 12px;
`;

export const Image = styled.img`
    width: 100%;
    object-fit: contain;
    border-radius: 8px;
`;
